export default __webpack_public_path__ + "static/media/call-green.f0633099.svg";